import React from "react";
import { Idle } from "@baseTypes/service/dashboard/IWorksDashboardService";
import { TooltipVariant } from "../IdlesTooltip";
import { TooltipGridCell, TooltipGridRow } from "@infobis/ui-styles-utils";
import st from "../IdlesTooltip.module.scss";
import cn from "classnames";
import {
    ChartCircle
} from "@modules/dashboards/dashboardTooltips/TooltipVariants/Circle/ChartCircle";
import { formatTime } from "@utils/format/time";
import {
    getConvertedPeriodAndExceedInfo
} from "@pages/dashboard/works/detalization/efficiency/IdlesChart/components/IdlesTooltip/utils/utils";

type IdlesTooltipContentProps = {
    idles: Idle[]
    variant: TooltipVariant
}
const RenderTooltipContent = (props: IdlesTooltipContentProps) => {
    const { variant, idles } = props

    return (
        <>
            {
                idles.map(idle => {
                    const { plan, fact, isExceed } = getConvertedPeriodAndExceedInfo(idle.fact, idle.plan);

                    return (
                        <TooltipGridRow key={idle.id}>
                            <TooltipGridCell
                                contentClassName={cn(st['tooltip__cell__content'], st[`tooltip__text--common--${variant}`])}
                            >
                                <ChartCircle color={idle.color || ''} text={idle.typeOfIdle || ''}/>
                            </TooltipGridCell>
                            <TooltipGridCell
                                align={'end'}
                                contentClassName={cn(st[`tooltip__text--common--${variant}`], isExceed && st[`tooltip__text--exceed--${variant}`])}
                            >
                                {formatTime(fact)}
                            </TooltipGridCell>
                            <TooltipGridCell
                                contentClassName={st[`tooltip__text--common--${variant}`]}
                                align={'end'}
                            >
                                {formatTime(plan)}
                            </TooltipGridCell>
                        </TooltipGridRow>
                    )
                })
            }
        </>
    )
}

export default RenderTooltipContent;